module.exports = __webpack_public_path__ + "static/media/icon_data-scientists.5164e56f.svg";